import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../string';
import { translatableValidator } from '../translatable';
import { areaBoundaryValidator } from './area-boundary';
import { rowValidator } from './row';
export const areaValidator = Validator.object({
    number: Validator.number({ min: 1 }),
    areaCategoryId: nonEmptyStringValidator,
    name: translatableValidator,
    boundary: areaBoundaryValidator,
    columnCount: Validator.number({ min: 0 }),
    rowCount: Validator.number({ min: 0 }),
    rows: Validator.array({ items: rowValidator })
});
